// useStore.js — React hook that subscribes a component to global store changes.
//
// Usage:
//   function MemberShell({ children }) {
//     useStoreVersion();   // re-renders this subtree on any store mutation
//     ...
//   }

import { useEffect, useState } from "react";
import { getVersion, subscribe } from "@/lib/store";

export function useStoreVersion() {
  const [v, setV] = useState(getVersion());
  useEffect(() => {
    return subscribe(() => setV(getVersion()));
  }, []);
  return v;
}
